import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const ReservationLoginShema = Yup.object().shape({
  email: Yup.string().required().email(),
  reservationNumber: Yup.number().required(),
});
